import { ElementForm } from '..';

export default (N_input: ElementForm) => {
	return N_input && N_input instanceof HTMLInputElement && N_input.type === 'radio';
};
